

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ContactAnonModule } from '@/store/modules/contactAnon';
import AnonJobWorkerInterviewContactConfirmationReply from '@/models/AnonJobWorkers/AnonJobWorkerInterviewContactConfirmationReply';
import PageNames from '@/router/PageNames';
import ListUtils from '@/lib/listUtils';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AppModule } from '@/store/modules/app';

@Component({
    name: 'ContactInterviewConfirmationConfirmDecline'
})
export default class extends GiganautVueDialog {

  public dialog = false;
  public request: AnonJobWorkerInterviewContactConfirmationReply = new AnonJobWorkerInterviewContactConfirmationReply();

  get allowDeclineInterview () {
      return ContactAnonModule.interviewConfirmation.allowDeclineInterview;
  }

  get interviewConfirmation() {
    return ContactAnonModule.interviewConfirmation;
  }

  get buttonLabel() {
    if (this.allowDeclineInterview) {
      return "CONFIRM/DECLINE";
    } else {
      return "CONFIRM";
    }    
  }

  get dialogTitle() {
    if (this.allowDeclineInterview) {
      return "Confirm or Decline Interview";
    } else {
      return "Confirm Interview";
    }    
  }

  get submitButtonLabel() {
    if (this.allowDeclineInterview) {
      return "SUBMIT";
    } else {
      return "CONFIRM";
    }   
  }
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      if (!this.allowDeclineInterview) {
        //Automatically tick the hidden tickbox
        this.request.confirmed = true;
      }
    }
  }

  get loading() {
    return ContactAnonModule.loadingDialog;
  }

  get declinedReasons() {
    return ListUtils.jobWorkerInterviewContactDeclinedReasons();
  }
	  
  async submit() { 
     if (!(this.$refs.form as any).validate()) {
      return;
    }
    await ContactAnonModule.interviewContactConfirmation(this.request);
    this.dialog = false;
    if (ContactAnonModule.isError) {
       this.$router.push({ name: PageNames.ContactError });
    }
  }
}
